import ListasActionsService from './listas-actions.service';
import DialogListasCompartirCtrl from './compartir/dialog-listas-compartir.controller';
import PopOverListasCtrl from './popover/popover-listas.controller';
import PopOverListas from './popover/popover-listas.directive';
import DialogListasPublicaCtrl from './publica/dialog-listas-publica.controller';
import angular from 'angular';
import ngResourceModuleName from 'angular-resource';

const ListasModule = angular
    .module('listas', ['app', ngResourceModuleName])
    .service('ListasActionsService', ListasActionsService)
    .controller('DialogListasCompartirCtrl', DialogListasCompartirCtrl)
    .controller('PopOverListasCtrl', PopOverListasCtrl)
    .directive('popoverListas', PopOverListas) //TODO: Pensar un nombre mejor para la directiva;
    .controller('DialogListasPublicaCtrl', DialogListasPublicaCtrl)
;

export default ListasModule;